import React from "react";
import "./Footer.scss";
function Footer() {
  return (
    <div className="footer-nav">
      <div className="link-mobile">
        <div className="header-link mobile-footer-link">
          <div className="mobile-policy-link">
            <a
              target="_blank"
              href={process.env.REACT_APP_PRIVACY_POLICY_URL}
              className="footer-mobile-hov"
            >
              Privacy Policy
            </a>
            <span>&#x2022;</span>
            <a
              target="_blank"
              href={process.env.REACT_APP_USER_AGREEMENT}
              className="footer-mobile-hov"
            >
              Terms
            </a>
          </div>

          <a
            href="https://getphyllo.com/"
            className="copy-right-mobile"
            target="_blank"
          >
            © 2023 Phyllo, All rights reserved by Phyllo Inc.
          </a>
        </div>
      </div>
      <a href="https://getphyllo.com/" className="desk-link" target="_blank">
        © 2023 Phyllo, All rights reserved by Phyllo Inc.
      </a>
    </div>
  );
}

export default Footer;
